module.exports = __webpack_public_path__ + "static/media/alexandra-daddario-icon.9faa8f3f.jpg";